import React, { useState, useEffect } from "react";
import registration from "../../assets/images/registration-img.png";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { login } from "../features/authSlice";
import { useNavigate } from "react-router-dom";
import { OTP_EXPIRATION_TIME } from "../../constants";
import OtpInput from '../OtpInput';

const VerifyPasswordModal = ({ mobileno }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const pass = useSelector((state) => state.auth.pass);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(OTP_EXPIRATION_TIME); // Start with 5 minutes
  const [isActive, setIsActive] = useState(true); // Start active

  useEffect(() => {
    let interval = null;
    if (isActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsActive(false);
    }
    return () => clearInterval(interval);
  }, [timeLeft, isActive]);

  const startTimer = () => {
    setTimeLeft(5 * 60); // 5 minutes
    setIsActive(true);
  };

  const formatTime = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const resetForm = () => {
    setOtp("");
    setLoading(false);
    setTimeLeft(5 * 60);
    setIsActive(true);
  };

  useEffect(() => {
    const verifyModal = document.getElementById("verify-otp");

    verifyModal.addEventListener("hidden.bs.modal", resetForm);
    verifyModal.addEventListener("show.bs.modal", resetForm);

    return () => {
      verifyModal.removeEventListener("hidden.bs.modal", resetForm);
      verifyModal.removeEventListener("show.bs.modal", resetForm);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/emails/verify-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: user, otp: otp }),
        }
      );
      const data = await response.json();
      // console.log(data, "data at verify password modal");
      if (data.success) {
        setLoading(true);
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/auth/register`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                email: user,
                password: pass,
                address: {
                  street: "",
                  country: "",
                  state: "",
                  city: "",
                  postalCode: "",
                },
              }),
            }
          );
          const data = await response.json();
          // console.log(data, "data at verify password modal");
          if (data.success) {
            toast.success(data.message);
            setLoading(false);
            dispatch(
              login({
                user: data.responseObject.user,
                token: data.responseObject.token,
              })
            );
            handleClose();
            // navigate("/");
            resetForm();
          } else {
            setLoading(false);
            resetForm();
            toast.error(data.message);
          }
        } catch (error) {
          setLoading(false);
        }
        setLoading(false);
      } else {
        setLoading(false);
        resetForm();
        toast.error(data.message);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleClose = () => {
    const modal = document.getElementById("verify-otp");
    const bsModal = window.bootstrap.Modal.getInstance(modal);
    bsModal.hide();
    const backdrop = document.getElementById("verify-otp");
    // console.log(backdrop);
    // backdrop.click()
    if (backdrop) {
      backdrop.remove();
    }
  };

  const handleResendOtp = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/emails/send-email-otp-auth`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name: user, email: user }),
        }
      );
      const data = await response.json();
      if (data.success) {
        startTimer(); // Reset timer when OTP is resent
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      // console.log("otp resend error", error);
    }
  };
  return (
    <>
      <div
        className="modal fade registration"
        id="verify-otp"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            >
              <i className="fa fa-times" />
            </button>
            <div className="modal-body">
              <div className="row gx-0">
                <div className="col-lg-6 h-100 d-xl-block d-lg-block d-none">
                  <div className="registration-img">
                    <img
                      src={registration}
                      className="w-100 h-100"
                      alt="registration"
                    />
                    <div className="registration-content">
                      <h3 className="text-white">Verify OTP</h3>
                      <p className="text-white">
                        Enter your credentials to verify your account.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="registration-frm">
                    <h4 className="title d-lg-none d-block">Verify OTP</h4>
                    <form action="" onSubmit={handleSubmit}>
                      <div className="registration-bx text-center">
                        <label htmlFor="" className="mb-3" style={{fontSize: '20px'}}>Enter OTP</label>
                        <OtpInput
                          length={4}
                          onOtpSubmit={(value) => setOtp(value)}
                        />
                      </div>
                      <div className="registration-bx">
                        <button
                          className="thm-btn dark w-100 rounded-5 p-3 bg-btn"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                      {/* <p className="text-center fz-18">0:30S</p> */}
                    </form>
                    <div className="text-center mt-4">
                      <p className="text-center fz-18 mb-2">
                        OTP valid for: {formatTime()}
                      </p>
                      <button
                        onClick={handleResendOtp}
                        className={`txt-org fw-600 ${
                          isActive ? "disabled" : ""
                        }`}
                        disabled={isActive}
                      >
                        Resend
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyPasswordModal;
